import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Icon, Card, Grid } from 'semantic-ui-react';
import './styles.css';

const UnitsTab = ({ building }) => {
  const history = useHistory();

  const handleManageUnits = () => {
    history.push(`/buildings/${building._id}/units`);
  };

  const bigDataCorpEnabled = building.configuration?.integrations?.bigDataCorp?.enabled || false;

  return (
    <div className="units-tab">
      <div className="hero-section">
        <div className="hero-decoration-1" />
        <div className="hero-decoration-2" />
        
        <div className="hero-content">
          <div className="hero-header">
            <div className="hero-icon">
              <Icon name="building outline" />
            </div>
            <div className="hero-text">
              <h1 className="hero-title">
                {building.name || 'É Noiz'}
              </h1>
              <h2 className="hero-subtitle">
                Gerenciamento de Unidades
              </h2>
              <p className="hero-description">
                Configure funcionalidades específicas por unidade
              </p>
            </div>
          </div>
          <div className={`bigdatacorp-status ${bigDataCorpEnabled ? 'active' : 'inactive'}`}>
            <div className={`status-dot ${bigDataCorpEnabled ? 'active' : 'inactive'}`} />
            <span>
              BigDataCorp {bigDataCorpEnabled ? 'Ativo' : 'Inativo'} no Condomínio
            </span>
          </div>
        </div>
      </div>
      <Grid columns={1} stackable className="no-margin">
        <Grid.Column>
          <Card fluid className="main-card">
            <Card.Content className="main-card-content">
              <div className="card-header">
                <div className="card-header-content">
                  <div className="card-icon-container">
                    <div className="card-icon">
                      <Icon name="shield" />
                    </div>
                    <div>
                      <h3 className="card-title">
                        BigDataCorp por Unidade
                      </h3>
                      <p className="card-subtitle">
                        Controle granular de segurança
                      </p>
                    </div>
                  </div>
                  
                  <p className="card-description">
                    Configure individualmente quais unidades devem ter o BigDataCorp habilitado,
                    independente da configuração geral do condomínio. Defina alertas personalizados
                    por email e WhatsApp para cada unidade.
                  </p>
                </div>
              </div>
              <Grid columns={4} stackable className="feature-grid">
                <Grid.Column textAlign="center">
                  <div className="feature-item">
                    <Icon name="toggle on" size="large" color="green" />
                    <h5 className="feature-title">Controle Individual</h5>
                    <p className="feature-description">
                      Ativar/desativar por unidade
                    </p>
                  </div>
                </Grid.Column>
                <Grid.Column textAlign="center">
                  <div className="feature-item">
                    <Icon name="mail" size="large" color="blue" />
                    <h5 className="feature-title">Alertas Email</h5>
                    <p className="feature-description">
                      Configuração personalizada
                    </p>
                  </div>
                </Grid.Column>
                <Grid.Column textAlign="center">
                  <div className="feature-item">
                    <Icon name="whatsapp" size="large" color="green" />
                    <h5 className="feature-title">WhatsApp</h5>
                    <p className="feature-description">
                      Notificações instantâneas
                    </p>
                  </div>
                </Grid.Column>
                <Grid.Column textAlign="center">
                  <div className="feature-item">
                    <Icon name="sliders horizontal" size="large" color="orange" />
                    <h5 className="feature-title">Tipos de Alertas</h5>
                    <p className="feature-description">
                      Personalização completa
                    </p>
                  </div>
                </Grid.Column>
              </Grid>
              <Button 
                primary 
                size="large"
                onClick={handleManageUnits}
                className="manage-button"
              >
                <Icon name="settings" />
                Gerenciar Unidades BigDataCorp
              </Button>
            </Card.Content>
          </Card>
          <Grid columns={2} stackable>
            {/* How it Works */}
            <Grid.Column>
              <Card fluid className="info-card">
                <Card.Content className="info-card-content">
                  <div className="info-card-header">
                    <div className="info-card-icon lightbulb">
                      <Icon name="lightbulb" />
                    </div>
                    <h4 className="info-card-title">
                      Como Funciona
                    </h4>
                  </div>
                  
                  <div className="info-card-text">
                    <div style={{ marginBottom: '20px' }}>
                      <div className="level-card condo">
                        <div className="level-header">
                          <Icon name="building" style={{ fontSize: '14px' }} />
                          <strong className="level-title condo">Nível Condomínio</strong>
                        </div>
                        <p className="level-description condo">
                          Gerencia entrada e saída de <strong>visitantes</strong> no módulo de portaria (lobby).
                          (Ativar na aba 'Planos')
                        </p>
                      </div>
                      <div className="level-card unit">
                        <div className="level-header">
                          <Icon name="home" style={{ fontSize: '14px', flexShrink: 0 }} />
                          <strong className="level-title unit">Nível Unidade</strong>
                        </div>
                        <p className="level-description unit">
                          Verificação de <strong>locatários</strong> em formulários de locação por temporada.
                          Ativa apenas para unidades específicas quando formulário é enviado.
                        </p>
                      </div>
                    </div>
                    
                    <div>
                      <h5 className="config-section-title">
                        Configuração por Unidade:
                      </h5>
                      <ul className="config-list">
                        <li className="config-item">
                          <Icon name="check" />
                          Ativar/desativar BigDataCorp independentemente
                        </li>
                        <li className="config-item">
                          <Icon name="check" />
                          Configurar emails para alertas
                        </li>
                        <li className="config-item">
                          <Icon name="check" />
                          Configurar WhatsApp para notificações
                        </li>
                        <li className="config-item">
                          <Icon name="check" />
                          Personalizar tipos de alertas
                        </li>
                      </ul>
                    </div>
                  </div>
                </Card.Content>
              </Card>
            </Grid.Column>

            {/* Alert Types */}
            <Grid.Column>
              <Card fluid className="info-card">
                <Card.Content className="info-card-content">
                  <div className="info-card-header">
                    <div className="info-card-icon warning">
                      <Icon name="warning sign" />
                    </div>
                    <h4 className="info-card-title">
                      Tipos de Alertas Disponíveis
                    </h4>
                  </div>
                  
                  <div className="info-card-text">
                    <div className="alert-types-grid">
                      <div className="alert-type-item warrant">
                        <Icon name="gavel" />
                        <div>
                          <strong className="alert-type-title">Mandados de prisão</strong>
                        </div>
                      </div>
                      
                      <div className="alert-type-item criminal">
                        <Icon name="file alternate" />
                        <div>
                          <strong className="alert-type-title">Antecedentes criminais</strong>
                        </div>
                      </div>
                      
                      <div className="alert-type-item pep">
                        <Icon name="user" />
                        <div>
                          <strong className="alert-type-title">Pessoas politicamente expostas (PEP)</strong>
                        </div>
                      </div>
                      
                      <div className="alert-type-item history">
                        <Icon name="history" />
                        <div>
                          <strong className="alert-type-title">Histórico criminal completo</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Content>
              </Card>
            </Grid.Column>
          </Grid>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default UnitsTab;